import { v4 as uuid } from "uuid";

export default function deviceIdReducer(state: string | null): string {
    if (!state) {
        return uuid();
    }
    return state;
}
